// src/components/Home.tsx
import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const BACKGROUND_URL = '/home-bg.png';

const HomeSection = styled.section<{ background: string }>`
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 4rem 2.5rem;
  background: 
    linear-gradient(rgba(24,26,27,0.7), rgba(24,26,27,0.7)),
    url(${props => props.background}) center/cover no-repeat;
  color: ${theme.colors.white};
  max-width: 1200px;
  margin: 0 auto;
  @media (max-width: 700px) {
    padding: 2.5rem 1rem;
  }
`;

const Title = styled.h1`
  color: ${theme.colors.green};
  font-size: 2.8rem;
  margin-bottom: 0.7rem;
`;

const Subtitle = styled.p`
  font-size: 1.25rem;
  color: #B7B7B7;
  margin-bottom: 2.5rem;
  max-width: 600px;
`;

const Button = styled.button`
  background: ${theme.colors.green};
  color: ${theme.colors.black};
  border: none;
  padding: 0.85rem 2.25rem;
  border-radius: 6px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 1.5rem;
`;

const Home: React.FC = () => {
  const { language } = useLanguage();
  const t = translations.home[language];

  return (
    <HomeSection id="home" background={BACKGROUND_URL}>
      <Title>{t.title}</Title>
      <Subtitle>
        {t.subtitle}<br />
        <span style={{ color: theme.colors.green, fontWeight: 500 }}>{t.tagline}</span>
      </Subtitle>
      <p style={{ maxWidth: 600, marginBottom: '2rem', color: theme.colors.white, fontSize: '1.15rem' }}>
        {t.description}
      </p>
      <Button as="a" href="#contact">{t.cta}</Button>
    </HomeSection>
  );
};

export default Home;
